// Bootstrap Imports

import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import ScrollBarHelper from 'bootstrap/js/src/util/scrollbar';

/*******************************************
 *  Helper Functions
 *******************************************/

// Handles flash of unstyled content.
function fouc() {
	const html = document.querySelector('html');
	html.classList.remove('no-js');
	html.classList.add('js');
}

// Optimize the scroll events for better browser performance.
//
// Broadcasts optimizedScroll event on the window.
// Use the same way you would add a window scroll listener.
// window.on('optimizedScroll', ...);
function optimizeScroll() {
	let scrollWaiting = false,
		endScrollHandle;
	window.addEventListener('scroll', () => {
		if (scrollWaiting) {
			return;
		}
		scrollWaiting = true;

		// clear previous scheduled endScrollHandle
		clearTimeout(endScrollHandle);

		window.dispatchEvent(new Event('optimizedScroll'));

		setTimeout(function () {
			scrollWaiting = false;
		}, 100);

		// schedule an extra execution of scroll() after 200ms
		// in case the scrolling stops in next 100ms
		endScrollHandle = setTimeout(function () {
			window.dispatchEvent(new Event('optimizedScroll'));
		}, 200);
	});
}

function mainNavigationScroll() {
	window.addEventListener('optimizedScroll', () => {
		const scrollY = window.scrollY;
		const masthead = document.getElementById('masthead');

		if (scrollY > 68) {
			masthead.classList.remove('top');
		} else {
			masthead.classList.add('top');
		}
	});
}

function mainNavigation() {
	mainNavigationScroll();

	const navCollapseEl = document.getElementById('main-menu-collapse');
	const masthead = document.getElementById('masthead');
	const scrollBar = new ScrollBarHelper();

	// Use Popper on navbar dropdowns
	Dropdown.prototype._detectNavbar = function () {
		// TODO only allow popper on larger devices.
		// Needs to support changing device sizes.
		return false;
	};

	// Solution to allow nested dropdowns with BSv5
	// https://jsfiddle.net/dallaslu/mvk4uhzL/
	const SHOW_CLASS_NAME = 'has-child-dropdown-show';
	Dropdown.prototype.toggle = (function (_orginal) {
		return function () {
			document
				.querySelectorAll('.' + SHOW_CLASS_NAME)
				.forEach(function (e) {
					e.classList.remove(SHOW_CLASS_NAME);
				});
			let dd = this._element
				.closest('.dropdown')
				.parentNode.closest('.dropdown');
			for (
				;
				dd && dd !== document;
				dd = dd.parentNode.closest('.dropdown')
			) {
				dd.classList.add(SHOW_CLASS_NAME);
			}
			return _orginal.call(this);
		};
	})(Dropdown.prototype.toggle);

	document.querySelectorAll('.dropdown').forEach(function (dd) {
		dd.addEventListener('hide.bs.dropdown', function (e) {
			if (this.classList.contains(SHOW_CLASS_NAME)) {
				this.classList.remove(SHOW_CLASS_NAME);
				e.preventDefault();
			}
			e.stopPropagation(); // do not need pop in multi level mode
		});
	});

	// Opt-in enable hover toggle on dropdowns
	// Add .dropdown-hover to the .dropdown, or add .dropdown-hover-all to a parent element.
	//
	// Note: it is generally a better idea to enable dropdowns on click.
	document
		.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown')
		.forEach(function (dd) {
			dd.addEventListener('mouseenter', function (e) {
				const toggle = e.target.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (!toggle.classList.contains('show')) {
					Dropdown.getOrCreateInstance(toggle).toggle();
					dd.classList.add(SHOW_CLASS_NAME);
					Dropdown.clearMenus();
				}
			});
			dd.addEventListener('mouseleave', function (e) {
				const toggle = e.target.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (toggle.classList.contains('show')) {
					Dropdown.getOrCreateInstance(toggle).toggle();
				}
			});
			// Redirect to link if it exists/is valid.
			dd.addEventListener('click', function () {
				const toggle = this.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (
					!toggle.getAttribute('href').lastIndexOf('#', 0) !== 0
				) {
					window.location.href = toggle.getAttribute('href');
				}
			});
		});

	// Prevent scroll while open
	navCollapseEl.addEventListener('show.bs.collapse', function () {
		masthead.style.paddingRight = `${scrollBar.getWidth()}px`;
		scrollBar.hide();
	});
	navCollapseEl.addEventListener('hide.bs.collapse', function () {
		masthead.style.paddingRight = '';
		scrollBar.reset();
	});

	// Close main navigation on resize
	window.addEventListener('resize', function () {
		if (
			typeof navCollapseEl !== 'undefined' &&
			navCollapseEl.classList.contains('show')
		) {
			const navCollapse = Collapse.getInstance(navCollapseEl);
			navCollapse.hide();
		}
	});
}

function sidebarMenuNavigation() {
	const siteNavEl = document.querySelector('#site-navigation');
	const hmaburgerMenu = document.querySelector('.navbar-toggler');
	const navCollapseEl = document.getElementById('main-menu-collapse');
	const sidebarMenuEl = document.getElementById('sidebar-nav-menu');
	const sidebarEl = sidebarMenuEl.querySelector('.sidebar-menu-container');
	const scrollBar = new ScrollBarHelper();

	const sidebarAnimation = gsap.timeline({paused: true, onReverseComplete: () => {
		sidebarMenuEl.classList.remove('is-active');
	}});

	sidebarAnimation.to(sidebarEl, {opacity: 1, x: 0, duration: 0.32})
	.from(sidebarEl.children, {
		x: 100,
		opacity: 0,
		stagger: {
		  ease: "power2.inOut",
		  each: 0.1
		}
	  });

	const resetSidebar = () => {
		sidebarAnimation.reverse();
		siteNavEl.classList.remove('is-sidebar-active');
		navCollapseEl.classList.remove('show');
		hmaburgerMenu.classList.add('collapsed')
		hmaburgerMenu.setAttribute('aria-expanded', false);
		scrollBar.reset();
	}

	sidebarMenuEl.addEventListener('click', (e) => {
		const el = e.target;

		if(el.classList.contains('is-active')) {
			resetSidebar();
		}
	});

	document.addEventListener('keydown', (e) => {
		if(e.key === 'Escape') resetSidebar();
	})


	navCollapseEl.addEventListener('show.bs.collapse', () => {
		sidebarMenuEl.classList.add('is-active');
		siteNavEl.classList.add('is-sidebar-active');
		sidebarAnimation.play();
	});

	navCollapseEl.addEventListener('hide.bs.collapse', () => {
		siteNavEl.classList.remove('is-sidebar-active');
		sidebarAnimation.reverse();
	});
}

/**
 * Popup Maker popups prevent body scroll on popups with an overlay.
 * To prevent layout shifting due to the disappearing scrollbar, an
 * offset is added via padding-right. However, the value from the plugin
 * is static and does not work on all browsers. This function calculates
 * the scrollbar size (if it exists) on each open event and applies the
 * required offset.
 */
function popupMakerOverlayFix() {
	if (typeof jQuery === undefined) { return }
	const pum = document.getElementsByClassName('pum');
	if (pum.length > 0) {
		const $page = jQuery('#page');
		const $adminbar = jQuery('#wpadminbar');
		const getScrollbarWidth = () => {
			const documentWidth = document.documentElement.clientWidth;
			return Math.abs(window.innerWidth - documentWidth);
		};
		const overlayDisabled = () => {
			const $popup = PUM.getPopup(this); // eslint-disable-line no-undef
			const settings = $popup.popmake('getSettings');
			return (
				'overlay_disabled' in settings && settings.overlay_disabled === true
			);
		};

		jQuery(document)
			.on('pumBeforeOpen', () => {
				if (overlayDisabled()) return;
				const width = getScrollbarWidth();
				$page.css('padding-right', `${width}px`);
				$adminbar.css('padding-right', `${width}px`);
			})
			.on('pumAfterClose', () => {
				if (overlayDisabled()) return;
				$page.css('padding-right', '');
				$adminbar.css('padding-right', '');
			});
	}
}

const loadMore = () =>{
	let locationsList = "";
	let locationsButton = "";
	let childNodes = [];
	try {
		locationsList = document.getElementsByClassName("single-locations__featured-projects")[0];
		locationsButton = document.getElementsByClassName("single-locations__featured-projects_load-more")[0];
		childNodes = [...locationsList.childNodes];
	} catch(err) {
		if(locationsButton){
			locationsButton.innerHTML="All Projects Shown";
			locationsButton.classList.add("inactive");
		}
		return;
	}

	let currentNumberOfPosts = 6;

	const checkHideButton = () =>{
		if(	childNodes.length <= currentNumberOfPosts){
			locationsButton.innerHTML="All Projects Shown";
			locationsButton.classList.add("inactive");
		}
	}


	const renderNodes = () =>{
		checkHideButton();
		childNodes.forEach((el, index) => {
			if (index===0) return
			if(index > currentNumberOfPosts){
				el.style.display = "none";
			}
			else{
				el.style.display = "block"
			}

		});
	}

	locationsButton.addEventListener("click", ()=>{
		currentNumberOfPosts+=6;
		renderNodes();
	})

	checkHideButton();
	renderNodes();
}

/*******************************************
 *  Custom Functions for the theme
 *******************************************/

/**
 * On Loads
 */
document.addEventListener('DOMContentLoaded', () => {
	fouc();
	optimizeScroll();
	mainNavigation();
	mainNavigationScroll();
	popupMakerOverlayFix();
	sidebarMenuNavigation();

	loadMore();
});
